import { create } from 'zustand'
import { formularioTopSlice } from './slices/formularioTopSlice'

const useTopStore = create((set,get) => ({
    isLoading: true,
    productos: [],
    multiImagenes: [],
    multiImagenesTemp: [], 
    sucursales :[],
    sucursalSelecionada:[],
    esMostrar: true,
    handleSucursales: (e) => {
      set({ sucursalSelecionada: [e] })
      set({ multiImagenesTemp: get().multiImagenes })
      set({ esMostrar: false })
      setTimeout(() => {
        set({ esMostrar: true })
      }, 50);
    },
    handleChangeImagen: (imagenesSucursal) => {
      const sucursalId = get().sucursalSelecionada[0]?.value;
      if(!sucursalId){
        set({ multiImagenesTemp: imagenesSucursal })
        return;
      }
      const otrasSucursales = get().multiImagenesTemp.filter((item) => item.sucursal !== sucursalId);
      set({ multiImagenesTemp: [...otrasSucursales, ...imagenesSucursal] })
    },
    ...formularioTopSlice(set,get),
    iniciar: async() => {
        await get().obtenerTop();
    },
    limpiar: () => {
      set({
        isLoading: true,
        productos: [],
        multiImagenes: []
      })
    }
}))
  
export default useTopStore
